SupportGPassStatusAndNotesPresentation =
	editable:
		status: "Awaiting seating information"
		notes: "We'll make seating information available at least 24 hours before the event. You'll be able to print your G-Pass as soon as you receive the information."
	not_editable:
		purchased:
			status:"Awaiting seating information"
			notes: "We'll make seating information available at least 24 hours before the event. You'll be able to print your G-Pass once you receive the information."
		available:
			status: "Ready to print"
			notes:"You can find your seating information on your G-pass. You'll be able to bypass will-call when you arrive at the event."
		redeemed:
			status: "Event has passed"
			notes: ""
		expired:
			status: "Event has passed"
			notes: ""
		expired_unredeemed:
			status: "Event has passed"
			notes: ""
		expired_redeemed:
			status: "Event has passed"
			notes: ""

module.exports = SupportGPassStatusAndNotesPresentation
